import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import InvestorRoutes from './investor/InvestorRoutes';
import LandingPage from './LandingPage';
import ManagerRoutes from './manager/ManagerRoutes';
import { RegistryProvider } from './store/RegistryStore';
import { ToastProvider } from './ui/feedback';
import { investorTheme, managerTheme } from './ui/theme';

export default function PrototypeApp() {
  return (
    <RegistryProvider>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <ThemeProvider theme={managerTheme}>
                <CssBaseline />
                <LandingPage />
              </ThemeProvider>
            }
          />
          <Route
            path="/manager/*"
            element={
              <ThemeProvider theme={managerTheme}>
                <CssBaseline />
                <ToastProvider>
                  <ManagerRoutes />
                </ToastProvider>
              </ThemeProvider>
            }
          />
          <Route
            path="/investor/*"
            element={
              <ThemeProvider theme={investorTheme}>
                <CssBaseline />
                <ToastProvider>
                  <InvestorRoutes />
                </ToastProvider>
              </ThemeProvider>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </HashRouter>
    </RegistryProvider>
  );
}
